import { render, staticRenderFns } from "./UserReport.vue?vue&type=template&id=1ebffd23&scoped=true&"
import script from "./UserReport.vue?vue&type=script&lang=js&"
export * from "./UserReport.vue?vue&type=script&lang=js&"
import style0 from "./UserReport.vue?vue&type=style&index=0&id=1ebffd23&scoped=true&lang=css&"
import style1 from "./UserReport.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebffd23",
  null
  
)

export default component.exports